import * as H from 'history'

export const goToUrl = (history: H.History, url: string, state?: object): void => {
  history.push({
    pathname: url,
    search: history.location.search,
    state
  })
}
